import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useHeader } from "../../Providers/HeaderContextProvider";
import { getVocabulary } from "../../Services/dialogueCreations";
import { CapturePage } from "./shared";
import { HUB_COPY } from "./copy";
import microphoneIcon from "../../Assets/icon/capture/microphone.svg";
import fileIcon from "../../Assets/icon/capture/file.svg";
import cameraIcon from "../../Assets/icon/capture/camera.svg";
import keyboardIcon from "../../Assets/icon/capture/keyboard.svg";
import chevronIcon from "../../Assets/icon/capture/chevron-right.svg";
import lockIcon from "../../Assets/icon/capture/lock.svg";

/**
 * Capture — the home tab that turns something from the member's life into a
 * private Dialogue (DCI; Figma 9856:14621).
 *
 * Everything is behind the member flag `dci_v26`, and with it off every DCI
 * route answers 404. The hub asks once, through the vocabulary read the
 * Confirm Source step needs anyway: a 404 there shows "not available" instead
 * of letting the member start a flow that cannot finish.
 */
const METHODS = [
  { key: "RECORDING", path: "/capture/record", icon: microphoneIcon, tone: "orange" },
  { key: "DOCUMENT", path: "/capture/document", icon: fileIcon, tone: "blue" },
  { key: "PHOTO", path: "/capture/photo", icon: cameraIcon, tone: "crayola" },
  { key: "TEXT", path: "/capture/text", icon: keyboardIcon, tone: "teal" },
];

function CaptureHub() {
  const navigate = useNavigate();
  const { setHeaderContent, setHeaderContentRightSideContent } = useHeader();
  const [available, setAvailable] = useState(null);

  useEffect(() => {
    setHeaderContent(true);
    setHeaderContentRightSideContent(true);
  }, [setHeaderContent, setHeaderContentRightSideContent]);

  useEffect(() => {
    let cancelled = false;
    getVocabulary()
      .then(() => !cancelled && setAvailable(true))
      .catch((e) => {
        if (cancelled) return;
        // Only a 404 means "not for this member". Anything else is transient:
        // let them try, and the step itself will say what went wrong.
        setAvailable(e?.response?.status === 404 ? false : true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <CapturePage className="cap-hub">
      <header className="cap-hub__header">
        <h1 className="cap-hub__title">{HUB_COPY.title}</h1>
      </header>
      <div className="cap-hub__intro">
        <h2 className="cap-hub__question">{HUB_COPY.question}</h2>
        <p className="cap-hub__hint">{HUB_COPY.hint}</p>
      </div>

      {available === false ? (
        <div className="cap-card cap-card--status">{HUB_COPY.unavailable}</div>
      ) : (
        <div className="cap-hub__methods">
          {METHODS.map((m) => {
            const copy = HUB_COPY.methods[m.key];
            return (
              <button
                key={m.key}
                type="button"
                className="cap-method"
                disabled={available === null}
                onClick={() => navigate(m.path)}
              >
                <span className={`cap-tile cap-tile--${m.tone}`}>
                  <img src={m.icon} alt="" width="24" height="24" />
                </span>
                <span className="cap-method__text">
                  <span className="cap-method__title">{copy.title}</span>
                  <span className="cap-method__body">{copy.body}</span>
                </span>
                <span className="cap-method__chevron">
                  <img src={chevronIcon} alt="" width="16" height="16" />
                </span>
              </button>
            );
          })}
        </div>
      )}

      <p className="cap-private">
        <img src={lockIcon} alt="" width="16" height="16" />
        {HUB_COPY.private}
      </p>
    </CapturePage>
  );
}

export default CaptureHub;
